

/**
 * HeroSection Component - Premium Dark Design
 * 
 * High-conversion hero with animated background, 3D mockup, 
 * and lead capture form. Designed to WOW visitors immediately.
 */
function HeroSection() {
    return (
        <section className="hero-section">
            {/* Animated Background */}
            <div className="hero-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>

            <div className="hero-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', width: '100%', maxWidth: '900px', margin: '0 auto', gap: '2rem' }}>
                {/* Content */}
                <div className="hero-content" style={{ maxWidth: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {/* Badge */}
                    <div className="hero-badge hero-badge-free" style={{ borderColor: 'rgba(239, 68, 68, 0.4)', background: 'rgba(239, 68, 68, 0.1)' }}>
                        <span className="badge-dot" style={{ background: '#ef4444', boxShadow: '0 0 12px #ef4444' }}></span>
                        <span style={{ color: '#fca5a5' }}>Proyectos en Pausa — Modo Mantenimiento</span>
                    </div>

                    {/* Headline */}
                    <h1 className="hero-title" style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)' }}>
                        Cresta está
                        <span className="gradient-text" style={{ background: 'linear-gradient(135deg, #ef4444, #f59e0b, #ec4899)', WebkitBackgroundClip: 'text', backgroundClip: 'text' }}>
                            en Construcción
                        </span>
                    </h1>

                    {/* Description */}
                    <p className="hero-description" style={{ fontSize: '1.25rem', maxWidth: '650px', margin: '0 auto 2.5rem' }}>
                        Actualmente nos encontramos redefiniendo nuestra plataforma y realizando labores de mantenimiento técnico. 
                        Por este motivo, las funciones de registro e inicio de sesión se encuentran temporalmente inactivas. 
                        <strong> Agradecemos profundamente tu paciencia y tu interés en Cresta.</strong>
                    </p>

                    {/* Maintenance Box */}
                    <div className="hero-form-container" style={{ width: '100%', maxWidth: '500px' }}>
                        <div className="hero-form" style={{ padding: '2.5rem', border: '1px solid rgba(255, 255, 255, 0.1)', background: 'rgba(255, 255, 255, 0.02)' }}>
                            <div style={{ fontSize: '3.5rem', marginBottom: '1rem', animation: 'pulse-dot 2s infinite' }}>🚧</div>
                            <h3 className="form-title" style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>Hasta pronto</h3>
                            <p style={{ color: 'var(--gray-400)', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
                                Estamos trabajando internamente para brindarte una mejor experiencia en el futuro. Regresaremos con novedades.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HeroSection;
